import React, { useState } from "react";
import "./userJourney.scss";
import { Typography, Button, Icon, Radio, Banner } from "@plum-xoxo/stores-dsm";
import { defaultCustomUrl, getColorFromTheme } from "../../../utils/helpers";
import MediaQuery from "react-responsive";

interface Props {
  redirectToLogin: any;
  custom_url: any;
  redirectToAccessibleRoute: any;
  redirectToXoxoCodeUseCase: any;
  setUserJourneyState: any;
}

const UserJourney: React.FC<Props> = ({
  redirectToLogin,
  custom_url,
  redirectToAccessibleRoute,
  redirectToXoxoCodeUseCase,
  setUserJourneyState,
}) => {
  const [selectedUseCaseValue, setRadioValue] = useState("");
  const UseCaseBlock = ({
    title = "",
    description = "",
    radioValue = "points",
    iconNameInfo = "",
  }) => {
    const isSelectedUseCase = selectedUseCaseValue === radioValue;
    const titleBlock = (isMobile = false) => {
      return (
        <Typography
          textType="body"
          fontWeight="semiBold"
          size="XL"
          color={
            isSelectedUseCase
              ? getColorFromTheme("primary", "300")
              : getColorFromTheme("grey", "800")
          }
          className={!isMobile ? "mb-1 mt-3" : ""}
        >
          {title}
        </Typography>
      );
    };
    return (
      <div
        className={`box ${isSelectedUseCase ? "selected" : ""}`}
        onClick={() => setRadioValue(radioValue)}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <div
              className={`useCaseIcon me-2 ${
                isSelectedUseCase ? "selected" : ""
              }`}
            >
              <Icon
                iconName={iconNameInfo}
                size={30}
                fill={
                  isSelectedUseCase
                    ? getColorFromTheme("primary", "300")
                    : getColorFromTheme("grey", "800")
                }
              />
            </div>

            <div className="ms-1">
              <MediaQuery maxDeviceWidth={991}>{titleBlock(true)}</MediaQuery>
            </div>
          </div>

          <Radio checked={isSelectedUseCase} value={radioValue} />
        </div>
        <MediaQuery minDeviceWidth={992}>{titleBlock()}</MediaQuery>
        <Typography
          className="mt-3"
          textType="body"
          color={
            isSelectedUseCase
              ? getColorFromTheme("grey", "900")
              : getColorFromTheme("grey", "600")
          }
          size="M"
        >
          {description}
        </Typography>
      </div>
    );
  };
  const redirectToGenericFlow = (xoxoCodeUseCase: boolean = false) => {
    const generatedBranding = defaultCustomUrl(custom_url);
    if (xoxoCodeUseCase) {
      redirectToXoxoCodeUseCase(generatedBranding);
    } else {
      redirectToAccessibleRoute(generatedBranding);
    }
  };
  const proceedToFutherStep = () => {
    setUserJourneyState(selectedUseCaseValue);
    if (selectedUseCaseValue === "points" || selectedUseCaseValue === "admin") {
      redirectToLogin();
    } else if (selectedUseCaseValue === "code") {
      redirectToGenericFlow(true);
    }
  };
  const CtaBlock = ({ isMobileView = false }) => {
    return (
      <>
        <Button
          className={!isMobileView ? "mb-4" : "w-100"}
          width={280}
          disabled={!selectedUseCaseValue}
          onClick={() => {
            if (selectedUseCaseValue) {
              proceedToFutherStep();
            }
            return;
          }}
          endIcon={
            <Icon
              iconName="ArrowRight"
              size="20"
              fill={getColorFromTheme("white", "900")}
            />
          }
        >
          <Typography
            textType="body"
            fontWeight="medium"
            size="M"
            color={getColorFromTheme("white", "900")}
          >
            Continue
          </Typography>
        </Button>
        <div
          className={`d-flex align-items-center ${
            isMobileView
              ? "justify-content-between w-100"
              : "justify-content-center"
          }`}
          onClick={() => {
            setUserJourneyState("");
            redirectToGenericFlow();
          }}
        >
          <Typography
            className="me-2 cursor-pointer"
            textType="body"
            fontWeight="medium"
            size={isMobileView ? "S" : "M"}
            fontDecoration="underline"
            color={getColorFromTheme("blue", "300")}
          >
            Explore Marketplace Without Redemption
          </Typography>
          <Icon
            className="me-2 cursor-pointer"
            iconName="ExternalLink"
            size="20"
            fill={getColorFromTheme("blue", "300")}
          />
        </div>
      </>
    );
  };
  return (
    <div className="userjourney-content">
      <div className="layout">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="text-center">
                <span className="logoHeader">
                  <img
                    src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1633439365/store/Logo/xoxoday-full.svg"
                    alt="company-logo"
                    height={64}
                  />
                </span>
                <MediaQuery maxDeviceWidth={991}>
                  <Typography
                    textType="body"
                    fontWeight="semiBold"
                    size="XL"
                    className="px-3"
                    variant='h3'
                  >
                    Welcome, choose what you want to do!
                  </Typography>
                </MediaQuery>
                <MediaQuery minDeviceWidth={992}>
                  <Typography fontWeight="semiBold" size="M" variant='h1'>
                    Welcome, choose what you want to do!
                  </Typography>
                </MediaQuery>

                <div className="d-flex justify-content-center align-items-center stepsBody">
                  <UseCaseBlock
                    title="Redeem Points"
                    description="Consume your reward points for exciting gift-cards, experiences and much more from our global catalog."
                    radioValue="points"
                    iconNameInfo="XoxoPoints"
                  />
                  <UseCaseBlock
                    title="Redeem Xoxo Code"
                    description="Consume your xoxo-code without login for exciting gift-cards, experiences and much more from our global catalog."
                    radioValue="code"
                    iconNameInfo="XoxoCode"
                  />
                  <MediaQuery minDeviceWidth={992}>
                    <UseCaseBlock
                      title="Login as Business Admin"
                      description="Access your admin portal to distribute and manage rewards and incentive for your organisation."
                      radioValue="admin"
                      iconNameInfo="System"
                    />
                  </MediaQuery>

                  <MediaQuery maxDeviceWidth={992}>
                    <div
                      style={{
                        width: 320,
                        textAlign: "left",
                      }}
                    >
                      <Banner
                        title="Want to Login as Business Admin?"
                        description="You need to access the portal on your desktop to be able to login as business admin."
                        iconName="InfoCircle"
                      />
                    </div>
                  </MediaQuery>
                </div>
                <MediaQuery minDeviceWidth={992}>
                  <CtaBlock />
                </MediaQuery>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MediaQuery minDeviceWidth={992}>
        <div className="userJourney-footer">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ transform: "scale(0.9,1)" }}
          >
            <Typography
              className="me-1"
              textType="body"
              size="S"
              color={getColorFromTheme("grey", "900")}
            >
              Having trouble with Login?
            </Typography>
            <div
              className="cursor-pointer d-flex justify-content-center align-items-center"
              onClick={() => window.open("https://www.xoxoday.com/support")}
            >
              <Typography
                className="me-1"
                textType="body"
                size="S"
                color={getColorFromTheme("blue", "300")}
              >
                Get Help
              </Typography>
              <Icon
                iconName="ExternalLink"
                size={12}
                fill={getColorFromTheme("blue", "300")}
              />
            </div>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={991}>
        <div className="mobile-footer-uj">
          <CtaBlock isMobileView />
        </div>
      </MediaQuery>
    </div>
  );
};

export default UserJourney;
